<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import RichTextRenderer from '~/components/utils/RichTextRenderer.vue'
import AuDialog from '~/components/ui/AuDialog.vue'

defineProps<{
  isOpen: boolean
  content: string
}>()

const emit = defineEmits(['closeGuide'])

const { t } = useI18n()
</script>

<template>
  <AuDialog
    :title="t('article.studentGuide')"
    :open="isOpen"
    size="xl"
    @update:open="emit('closeGuide')"
  >
    <template #content>
      <article class="prose prose-au prose-img:rounded-xl mx-auto">
        <div class="au-teacher-article">
          <RichTextRenderer :text="content" />
        </div>
      </article>
    </template>
  </AuDialog>
</template>
